import { render, staticRenderFns } from "./CounterService.vue?vue&type=template&id=229ce7ae&scoped=true"
import script from "./CounterService.vue?vue&type=script&lang=js"
export * from "./CounterService.vue?vue&type=script&lang=js"
import style0 from "./CounterService.vue?vue&type=style&index=0&id=229ce7ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229ce7ae",
  null
  
)

export default component.exports